import type { EntryInterfaceTypeFragment } from '#graphql-operations'

/**
 * @param section - section handles of the filter entries (e.g. categories)
 * @param relatedSection - when set, only filters related to at least one entry of these sections are returned
 */
export default async function fetchArchiveFilters(section?: string[], relatedSection?: string[]): Promise<EntryInterfaceTypeFragment[]> {
  let entries: EntryInterfaceTypeFragment[] = []

  if (!section || !section?.length) {
    console.warn('[fetchFilters] - section is required')
    return entries
  }

  const { data } = await useGraphqlQuery('Entries', {
    section,
    relatedToEntries: relatedSection?.length ? [{ section: relatedSection }] : undefined,
  })
  entries = data.entries as EntryInterfaceTypeFragment[]

  return entries
}
